import MLLineTypeUtil from './MLLineTypeUtil';
import MLProductCodeUtil from './MLProductCodeUtil';

export default {

    getProductName: (code) => {
        if (MLLineTypeUtil.isHomeOwners(code) || MLProductCodeUtil.isHomeOwners(code)) {
            return 'Home';
        }
        if (MLLineTypeUtil.isPersonalAuto(code) || MLProductCodeUtil.isPersonalAuto(code)) {
            return 'Auto';
        }
        if (MLLineTypeUtil.isPersonalUmbrella(code) || MLProductCodeUtil.isPersonalUmbrella(code)) {
            return 'Umbrella';
        }

        return '';
    },
    getCoveragePartTypeName: (coveragePartType) => {
        if (MLProductCodeUtil.isHomeOwnersPartialTypeRental(coveragePartType)) {
            return 'Renters';
        }
        if (MLProductCodeUtil.isHomeOwnersPartialTypeCondo(coveragePartType)) {
            return 'Condo';
        }
        if (MLProductCodeUtil.isHomeOwnersPartialTypeHome(coveragePartType)) {
            return 'Home';
        }
        if (MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(coveragePartType)) {
            return 'Landlord Home';
        }
        if (MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(coveragePartType)) {
            return 'Landlord Condo';
        }

        return '';
    }
};
